import member_mo from "../../../assets/images/member_mo.webp";
import member_pc1 from "../../../assets/images/member_pc1.webp";
import ar_white from "../../../assets/images/ar_white.svg";
import home_white from "../../../assets/images/home_white.svg";

export default function MemberBanner() {
  return (
    <div className="w-full ">
      <div className="block md:hidden lg:hidden w-full relative  h-[12rem] mt-16">
        <img src={member_mo} alt="mobi" className="w-full h-[12rem]" />
        <div className="w-full absolute top-0 bg-blue-sky-gradient6 h-[12rem] ">
          <div className="absolute bottom-[30%] right-[15%] flex flex-col gap-2 items-center justify-center">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-around">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Đội ngũ thành viên
                </p>
              </div>
            </div>
            <p className="text-[1.5rem] font-semibold text-white whitespace-nowrap">
              Đội ngũ thành viên
            </p>
          </div>
        </div>
      </div>
      <div className="hidden md:block lg:block w-full relative h-[20rem] mt-28">
        <img src={member_pc1} alt="pc" className="w-full h-[20rem]" />
        <div className="w-full absolute top-0 bg-blue-sky-gradient6 h-[20rem] ">
          <div className="absolute bottom-[35%] right-[45%] md:right-[35%] lg:right-[40%] flex flex-col gap-2 items-center justify-center">
            <div className="w-full h-[2.625rem] rounded-[40px] flex items-center justify-around">
              <div className="flex items-center gap-2">
                <img src={home_white} alt="home1" />
                <img src={ar_white} alt="ar" />
              </div>
              <div>
                <p className="text-[1rem] font-normal text-white whitespace-nowrap">
                  Về chúng tôi
                </p>
              </div>
              <img src={ar_white} alt="ar" />
              <div>
                <p className="text-[1rem] font-normal text-white pl-4">
                  Đội ngũ
                </p>
              </div>
            </div>
            <p className="text-[2.25rem] font-semibold text-white">
              Đội ngũ thành viên
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
